import React from 'react';

const SplashScreen = ({ fadeOut }) => {
    return (
        <div className="splash-cinematic" style={{ opacity: fadeOut ? 0 : 1, visibility: fadeOut ? 'hidden' : 'visible' }}>
            <div className="splash-logo-reveal text-center px-4">
                <h1 className="splash-title section-head-main">
                    AL WASEEQ DESIGN
                </h1>
                <p className="splash-tagline" style={{
                    color: '#fff',
                    letterSpacing: '8px',
                    fontSize: 'clamp(0.6rem, 2vw, 0.8rem)',
                    textTransform: 'uppercase',
                    fontWeight: '300',
                    marginTop: '15px',
                    opacity: '0.6'
                }}>
                    We Craft Your Dream World
                </p>
            </div>

            <div className="splash-footer position-absolute bottom-0 start-0 w-100 py-4 text-center px-3">
                <div className="d-flex align-items-center justify-content-center flex-wrap gap-2" style={{ opacity: 0.8 }}>
                    <span className="section-index m-0" style={{ fontSize: '0.6rem' }}>POWERED BY</span>
                    <span className="powered-text" style={{ fontWeight: '300' }}>
                        SAFPRO TECHNOLOGY SOLUTIONS
                    </span>
                </div>
            </div>

            <style>{`
                .splash-logo {
                    height: 80px;
                    filter: brightness(1.2);
                }

                .splash-title {
                    font-size: 2.8rem;
                    color: #fff;
                    letter-spacing: 12px;
                    margin: 0;
                }

                .powered-text {
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 0.75rem;
                    letter-spacing: 4px;
                }

                @media (max-width: 768px) {
                    .splash-logo {
                        height: 60px;
                    }
                    .splash-title {
                        font-size: 1.8rem;
                        letter-spacing: 6px;
                    }
                    .powered-text {
                        font-size: 0.65rem;
                        letter-spacing: 2px;
                    }
                }

                @media (max-width: 480px) {
                    .splash-logo {
                        height: 50px;
                    }
                    .splash-title {
                        font-size: 1.4rem;
                        letter-spacing: 4px;
                    }
                    .powered-text {
                        font-size: 0.6rem;
                        letter-spacing: 1.5px;
                    }
                    .splash-footer {
                        padding-bottom: 30px !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default SplashScreen;

